import { render, staticRenderFns } from "./ShowTextHelper.vue?vue&type=template&id=bdd07288&"
import script from "./ShowTextHelper.vue?vue&type=script&lang=js&"
export * from "./ShowTextHelper.vue?vue&type=script&lang=js&"
import style0 from "./ShowTextHelper.vue?vue&type=style&index=0&id=bdd07288&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports